var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-edicion',[_c('page-header',{attrs:{"title":"Crear duración de contrato","back-to":"/duracionesContrato"}}),_c('formulario',{attrs:{"duracion-contrato":_vm.duracionContrato},on:{"submit":_vm.insertar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }